"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenderedTokenType = exports.RenderedTokenType = void 0;
var RenderedTokenType;
(function (RenderedTokenType) {
    RenderedTokenType["NFT"] = "NFT";
    RenderedTokenType["SLP"] = "SLP";
    RenderedTokenType["COLLECTION"] = "Collection";
    RenderedTokenType["MINTVAULT"] = "Mint Vault";
    RenderedTokenType["ALP"] = "ALP";
    RenderedTokenType["ALP_UNKNOWN"] = "Unknown ALP";
    RenderedTokenType["SLP_UNKNOWN"] = "Unknown SLP";
    RenderedTokenType["UNKNOWN_UNKNOWN"] = "Unknown Token Type";
    RenderedTokenType["FAN_OUT"] = "Fan Output Tx";
})(RenderedTokenType || (exports.RenderedTokenType = RenderedTokenType = {}));
const getRenderedTokenType = (tokenType) => {
    const { protocol, type } = tokenType;
    if (protocol === 'ALP') {
        switch (type) {
            case 'ALP_TOKEN_TYPE_STANDARD': {
                return RenderedTokenType.ALP;
            }
            case 'ALP_TOKEN_TYPE_UNKNOWN': {
                return RenderedTokenType.ALP_UNKNOWN;
            }
            default: {
                return RenderedTokenType.ALP_UNKNOWN;
            }
        }
    }
    else if (protocol === 'SLP') {
        switch (type) {
            case 'SLP_TOKEN_TYPE_FUNGIBLE': {
                return RenderedTokenType.SLP;
            }
            case 'SLP_TOKEN_TYPE_MINT_VAULT': {
                return RenderedTokenType.MINTVAULT;
            }
            case 'SLP_TOKEN_TYPE_NFT1_GROUP': {
                return RenderedTokenType.COLLECTION;
            }
            case 'SLP_TOKEN_TYPE_NFT1_CHILD': {
                return RenderedTokenType.NFT;
            }
            case 'SLP_TOKEN_TYPE_UNKNOWN': {
                return RenderedTokenType.SLP_UNKNOWN;
            }
            default: {
                return RenderedTokenType.SLP_UNKNOWN;
            }
        }
    }
    else {
        return RenderedTokenType.UNKNOWN_UNKNOWN;
    }
};
exports.getRenderedTokenType = getRenderedTokenType;
//# sourceMappingURL=tokenProtocol.js.map